<div class="warpper-question">
    <div class="warp-parts">
        <div class="parts">
            <p translate>questionBoard.edit.table.columns</p>
            <que-table-part *ngFor="let tq of questionForm.controls.columns.controls,let i=index" [formControl]="tq"
                (deleteEvent)="deleteColumn(i)"></que-table-part>
            <div class="pointer addOp right" (click)="addColumn()" translate>
                <img src="/assets/images/options/add-option.svg">
                questionBoard.edit.table.add-columns
            </div>
        </div>
        <div class="parts">
            <p translate>questionBoard.edit.table.rows</p>
            <que-table-part *ngFor="let tq of questionForm.controls.rows.controls,let i=index" [formControl]="tq"
                (deleteEvent)="deleteRow(i)"></que-table-part>
            <div class="pointer addOp right" (click)="addRow()" translate>
                <img src="/assets/images/options/add-option.svg">
                questionBoard.edit.table.add-columns
            </div>
        </div>
    </div>
</div>